module.exports = __webpack_public_path__ + "img/2_234.343ea389.png";